import { Subject } from 'rxjs';
import { Injectable } from "@angular/core";

@Injectable()
export class ProgressService {
    progressEventObservable: Subject<any> = new Subject();
}
